import { CostBasisResponseDto } from '@/models/RothDetailsDTO.model';
import ParticipantService from '@/services/Participant.service';
import { Stack } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { FC } from 'react';

import CostBasisDetailsTable from './CostBasisDetailsTable.component';

type ParticipantCostBasisProps = {
  participantId: string;
};

export const ParticipantCostBasis: FC<ParticipantCostBasisProps> = props => {
  const costBasisDetailsQuery = useQuery<CostBasisResponseDto>(
    ['ParticipantService.getCostBasisDetails', +props.participantId],
    () => {
      return ParticipantService.getCostBasisDetails(+props.participantId);
    },
    {
      enabled: Boolean(+props.participantId),
      staleTime: Infinity
    }
  );

  if (costBasisDetailsQuery.isFetching) {
    return <p>Loading....</p>;
  }

  if (!costBasisDetailsQuery.isSuccess) {
    return <p>Error</p>;
  }

  return (
    <Stack gap={2}>
      <CostBasisDetailsTable
        costBasisDetails={costBasisDetailsQuery.data.data}
        costType='roth'
        participantId={props.participantId}
        title='Roth'
      />
      <CostBasisDetailsTable
        costBasisDetails={costBasisDetailsQuery.data.data}
        costType='aftertax'
        participantId={props.participantId}
        title='After-Tax'
      />
    </Stack>
  );
};
